/* eslint-disable max-len */
/**
 * @file 容器组件
 * @author zhangzhicheng04 <zhangzhicheng04@baidu.com>
 */

import {getCharacterInfo} from '@components/chat/service';
import {CFooterButton} from '@components/c-footerbutton';
import {CHeadDeflector} from '@components/c-headdeflector';
import {
    getBackgroundUrlForShare,
    getQueryString,
} from '@lib/utils/tools';
import {Component} from '@src/lib/San';
import {UgInvokeApp} from '@src/lib/utils/ugInvokeApp';
// @ts-ignore
import CError from '../components/c-error';
import $style from './app.module.less';
const guideLogo = 'https://newapp-prompt.cdn.bcebos.com/bgimg/2025-10/db275ec41ef8ce61df5d1c9b6a4c793f.png';

const characterId = getQueryString('characterId') || '';
const uk = getQueryString('uk') || '';

class App extends Component {
    static template = /* html */ `
        <div
            class="{{$style.share}}"
        >
            <c-headdeflector
                class="{{$style.topBar}}"
                btn-text="APP内对话"
                scene-name="{{sceneName}}"
                guide-logo="{{guideLogo}}"
                ug-invoke="{{ugInvoke}}"
            />

            <c-error s-if="isOffline" on-invoke-app="invokeApp"/>

            <template s-else>
                <!-- 头像抠图 + 背景图 -->
                <div s-if="backgroundType === 'ugc'">
                    <!-- 背景图 需要取色逻辑 -->
                    <div
                        s-if="backgroundUrl"
                        style="background-image: url({{backgroundUrl}});"
                        class="{{$style.coverBg}}"
                    ></div>
                    <!-- 头像 -->
                    <div
                        s-if="faceSwapperUrl"
                        style="background-image: url({{faceSwapperUrl}})"
                        class="{{$style.coverBg}}"
                    ></div>
                </div>
                <!-- 单图背景 -->
                <div
                    s-if="showBgUrl"
                    style="background-image: url({{showBgUrl}}); {{showNoBgUrlStyle ? 'filter: blur(20px)' : ''}}"
                    class="{{$style.coverBg}}"
                >
                </div>
                <div s-if="showNoBgUrlStyle" class="{{$style.pureBg}}"></div>
                <div
                    s-if="showNoBgUrlStyle"
                    class="{{$style.avatar}}"
                    style="background-image: url({{avatarUrl}});"
                >
                </div>
                <div class="{{$style.mask}}"></div>

                <div s-if="characterName" class="{{$style.characterName}}">
                    {{ characterName }}
                </div>

                <div s-if="author" class="{{$style.author}}">
                    @{{ author }}
                </div>

                <div
                    class="{{$style.text}}" style="width:{{textWidth}}px;"
                    on-click="handleClick"
                >
                    文字聊天<span></span>
                </div>
                <c-footerbutton
                    id="footerButton"
                    class="{{$style.footer}}"
                    btn-text="打开APP和Ta语音聊天"
                    scene-name="{{sceneName}}"
                    btn-style="talk"
                    ug-invoke="{{ugInvoke}}"
                />
            </template>
        </div>
    `;

    static components = {
        'c-error': CError,
        'c-headdeflector': CHeadDeflector,
        'c-footerbutton': CFooterButton,
    };

    static computed: Computed = {
        sceneName() {
            const isOffline = this.data.get('isOffline');
            // 下线跳首页
            return isOffline ? 'invoke_home' : 'character_immersive_page_new';
        },
    };

    initData() {
        return {
            $style,
            ugInvoke: new UgInvokeApp(),
            // prompt\character场景互斥公用一个
            infoAbortControl: new AbortController(),
            guideLogo,
            showNoBgUrlStyle: '',
            showBgUrl: '',
            backgroundType: '',
            backgroundUrl: '',
            videoBackgroundImage: '',
            faceSwapperUrl: '',
            avatarUrl: '',
        };
    }

    attached(): void {
        const footerButton = document.getElementById('footerButton');
        this.data.set('textWidth', footerButton?.clientWidth);
    }

    created(): void {
        this.getCharacterData();
    }

    async getCharacterData() {
        try {
            const res: any = await getCharacterInfo({
                characterId,
                from: 'charactervoiceshare',
            }, this.data.get('infoAbortControl'));

            const {errno, data = {}} = res || {};
            if (+errno !== 0) {
                // @ts-ignore
                throw new Error(`getCharacterInfo error errno= ${errno}`, {
                    cause: res,
                });
            }
            const {characterInfo = {}} = data;
            const {
                status,
                characterName,
                author,
            } = characterInfo;

            document.title = `文心-${characterName}`;

            this.data.set('characterInfo', characterInfo);
            this.data.set('characterName', characterName);
            this.data.set('author', author?.nickName);
            this.data.set('isOffline', !status);
            this.handleSetBackgroundUrl(characterInfo);
            this.getInvokeInfo();
        }
        catch (e: any) {
            this.data.set('showBgUrl', 'https://newapp-prompt.cdn.bcebos.com/bgimg/2024-01/b09807908867184cc5a3a1329ee20bb1.png');
        }
    }
    // 跳转文字聊天
    handleClick() {
        // eslint-disable-next-line xss/no-location-href-assign
        window.location.href = `/talk/litechat?uk=${uk}&characterId=${characterId}&from=newapp`;
    }

    handleSetBackgroundUrl(info: any = {}) {
        // 有可用的背景图直接用
        const {coverUrl = '', avatarUrl}  = info;
        if (coverUrl) {
            this.data.set('showBgUrl', coverUrl);
        }
        else {
            const {
                type = '',
                backgroundUrl = '',
                videoBackgroundImage = '',
                faceSwapperUrl = '',
            } = getBackgroundUrlForShare(info);
            // 没有匹配的type 直接走兜底逻辑 取头像的颜色 来充当背景色
            if (!type
                || (type === 'ugc' && !(backgroundUrl && faceSwapperUrl))
                || type !== 'ugc' && !videoBackgroundImage
            ) {
                this.data.set('showBgUrl', avatarUrl);
                this.data.set('avatarUrl', avatarUrl);
                this.data.set('showNoBgUrlStyle', true);
                return;
            }
            this.data.set('backgroundType', type);
            backgroundUrl && this.data.set('backgroundUrl', backgroundUrl);
            videoBackgroundImage && this.data.set('showBgUrl', videoBackgroundImage);
            faceSwapperUrl && this.data.set('faceSwapperUrl', faceSwapperUrl);
        }
    }

    invokeApp() {
        const ugInvoke = this.data.get('ugInvoke');
        const sceneName = this.data.get('sceneName');
        ugInvoke?.execInvoke(sceneName);
    }

    getInvokeInfo() {
        const ugInvoke = this.data.get('ugInvoke');
        const {schemas} = this.data.get('characterInfo') || {};
        /* eslint-disable camelcase */
        ugInvoke.getInvokeInfo({
            // key是在七巧板回流服务配置的场景名称
            character_immersive_page_new: {
                params: schemas?.chatSchema,
            },
            invoke_home: {
                extFrom: 'share',
            },
        });

    }
}
export default App;
